import React from "react";
import { IconButton } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import { AutocompleteChangeReason } from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import { GenresArray } from "../../components/constants";
import { styles, useStyles } from "../../pages/Mint/styles";
import { autoCompleteErrorStyle } from "../../pages/Mint/styles";
import { autoCompleteStyle } from "../../pages/Mint/styles";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { LightTooltip } from "../../components/LightToolTip/LightToolTip";
import { MintSongDetailsProps } from "./types";
import { APP_BACKGROUND_COLOR, FONT_FAMILY, TEXT_COLOR } from "../../theme";

export const MintSongDetails: React.FC<MintSongDetailsProps> = ({
  setShowWalletTooltip,
  showWalletTooltip,
  handleShowWalletTooltip,
  connectedWallet,
  errors,
  touched,
  values,
  handleChange,
  handleBlur,
  isSubmitting,
  genres,
  setGenres,
  setFieldValue,
  setShowBpmTooltip,
  showBpmTooltip,
  handleShowBpmTooltip,
}) => {
  const classes = useStyles();
  return (
    <>
      <div className="input">
        <label style={{ color: TEXT_COLOR }} htmlFor="artist">
          Wallet Address
          <div
            style={{ display: "inline" }}
            onMouseOver={() => setShowWalletTooltip(true)}
            onMouseLeave={() => setShowWalletTooltip(false)}
          >
            <LightTooltip
              title="This is the wallet address you used on sign up, you can change the wallet address in Settings"
              placement="top"
              open={showWalletTooltip}
              onClick={handleShowWalletTooltip}
            >
              <IconButton disableRipple>
                <HelpOutlineIcon
                  color="info"
                  style={{ height: 16, width: 16 }}
                />
              </IconButton>
            </LightTooltip>
          </div>
        </label>
        <input
          type="text"
          name="artist"
          id="artist"
          placeholder="Address"
          defaultValue={connectedWallet}
          style={{ backgroundColor: "#61627A", color: TEXT_COLOR }}
          disabled
        />
      </div>
      <div className="input">
        <label
          style={{
            color: errors.artist && touched.artist ? "red" : TEXT_COLOR,
          }}
          htmlFor="artist"
        >
          Artist
          <span className="asterisk">*</span>
        </label>
        <input
          style={{
            backgroundColor: APP_BACKGROUND_COLOR,
            color: TEXT_COLOR,
            borderColor: errors.artist && touched.artist ? "red" : TEXT_COLOR,
          }}
          type="text"
          name="artist"
          id="artist"
          placeholder="Artist"
          value={values.artist}
          onChange={handleChange}
          onBlur={handleBlur}
          disabled={isSubmitting}
        />
      </div>

      <div className="input">
        <label
          style={{
            color: errors.title && touched.title ? "red" : TEXT_COLOR,
          }}
          htmlFor="title"
        >
          Title
          <span className="asterisk">*</span>
        </label>
        <input
          style={{
            backgroundColor: APP_BACKGROUND_COLOR,
            color: TEXT_COLOR,
            borderColor: errors.title && touched.title ? "red" : TEXT_COLOR,
          }}
          type="text"
          name="title"
          id="title"
          placeholder="Song Title"
          value={values.title}
          onChange={handleChange}
          onBlur={handleBlur}
          disabled={isSubmitting}
        />
      </div>

      <div className="input">
        <label
          style={{
            color:
              errors.description && touched.description ? "red" : TEXT_COLOR,
          }}
          htmlFor="description"
        >
          Description
          <span className="asterisk">*</span>
        </label>
        <textarea
          style={{
            backgroundColor: APP_BACKGROUND_COLOR,
            color: TEXT_COLOR,
            borderColor:
              errors.description && touched.description ? "red" : TEXT_COLOR,
          }}
          name="description"
          id="description"
          placeholder="NFT Description"
          value={values.description}
          onChange={handleChange}
          onBlur={handleBlur}
          cols={30}
          rows={4}
          disabled={isSubmitting}
        ></textarea>
      </div>
      <div>
        <div style={{ marginBottom: 20 }}>
          <label
            htmlFor="bio"
            style={{
              ...styles.genreLabel,
              ...{
                color: errors.genres && touched.genres ? "red" : TEXT_COLOR,
              },
            }}
          >
            Genres
            <span className="asterisk">*</span>
          </label>
          <Stack spacing={3} sx={{}}>
            <Autocomplete
              disabled={isSubmitting}
              autoComplete
              value={genres[0] || null}
              sx={
                errors.genres && touched.genres
                  ? autoCompleteErrorStyle
                  : autoCompleteStyle
              }
              options={GenresArray}
              onChange={(
                event: React.SyntheticEvent<Element, Event>,
                value: string | null,
                _reason: AutocompleteChangeReason
              ) => {
                if (value != null) {
                  setGenres([value]);
                  setFieldValue("genres", value);
                }
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label=" "
                  InputLabelProps={{
                    shrink: false,
                  }}
                  classes={{ root: classes.customTextField }}
                />
              )}
              renderOption={(props, option) => (
                <li {...props} style={{ fontFamily: FONT_FAMILY }}>
                  {option}
                </li>
              )}
            />
          </Stack>
        </div>
      </div>
      <div className="input">
        <label htmlFor="bpm" style={styles.bpmContainer}>
          BPM <span className="optional-input">(optional)</span>
          <div
            style={{ display: "inline" }}
            onMouseOver={() => setShowBpmTooltip(true)}
            onMouseLeave={() => setShowBpmTooltip(false)}
          >
            <LightTooltip
              title="Beats per minute"
              placement="top"
              open={showBpmTooltip}
              onClick={handleShowBpmTooltip}
            >
              <IconButton disableRipple>
                <HelpOutlineIcon
                  color="info"
                  style={{ height: 16, width: 16 }}
                />
              </IconButton>
            </LightTooltip>
          </div>
        </label>
        <div style={{ display: "flex", flexDirection: "row" }}>
          <input
            style={{ backgroundColor: APP_BACKGROUND_COLOR, color: TEXT_COLOR }}
            type="number"
            name="bpm"
            id="bpm"
            min="0"
            max="200"
            step="1"
            placeholder="BPM range 0-200"
            value={values.bpm}
            onChange={handleChange}
            onBlur={handleBlur}
            disabled={isSubmitting}
          />
        </div>
      </div>
    </>
  );
};
